<template>
  <el-row v-loading="loading">
    <el-row class="padding_5px_top padding_10px_bottom">
      <el-col style="width: 502px;">
        <el-col :span="7" class="database_search">
          通过基金代码查询
        </el-col>

        <el-col :span="11" class="left_text_align" id="database_input">
          <el-popover placement="bottom" width="380px" v-model="searchPopoverVisible">
            <el-row style="width: 380px; height: 300px;" v-loading="loading2">
              <el-scrollbar ref="search_scrollbar" style="height: 100%;">
                <el-row style="
                                        text-align: left;
                                        margin: 0;
                                        font-size: 12px;
                                        cursor: pointer;
                                    " v-for="(node, index) in state" class="fundInformation" :key="index">
                  <el-col :span="24" v-html="node" @click.native="getFundInformation(node)" :ref="'cssClass' + index"
                    @mouseenter.native="
                      changeClass($event, index)
                      " :class="{ searchHover: 1 === index }"></el-col>
                </el-row>
              </el-scrollbar>
            </el-row>
            <el-input placeholder="请输入基金代码或基金名称" slot="reference" type="text" v-model="symbol"
              @input="searchFundCache(symbol)"></el-input>
          </el-popover>
        </el-col>
        <el-col :span="3" class="right_text_align">
          <el-button @click="searchFundInformation()" type="primary">查询</el-button>
        </el-col>
      </el-col>
    </el-row>
    <el-row v-if="showFund">
      <el-divider></el-divider>
      <el-row class="width-950">
        <el-row>
          <el-col :span="24" class="padding_20px_bottom" style="text-align:left;">
            <el-col :span="24">
              <div class="database_title" style="float:left">{{ fundInfo.className }} {{ fundInfo.symbol }}</div>
              <div v-if="showTerminatedFundInfo" class="padding_10px_left database_list"
                style="color: red;float:left;padding-top:3px;">该基金已终止</div>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-col :span="8" class="database_list">
              发行日期: <span>{{ fundInfo.ipoDate }}</span>
            </el-col>
            <el-col :span="8" class="database_list">
              成立日期: <span>{{ fundInfo.inceptionDate }}</span>
            </el-col>
            <el-col :span="8" class="database_list">
              基金类别:
              <span>{{ fundInfo.specialCategory }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="padding_20px_bottom">
            <el-col :span="8" class="database_list">
              最新风险等级: <span>{{ fundInfo.riskText }}</span>
            </el-col>
            <el-col :span="8" class="database_list">
              最新规模: <span>{{ fundInfo.totalNetAsset }}元</span>
              <el-tooltip class="item" effect="light" content="数据来源于基金最近一期定期报告，多份额合并计算，以人民币计" placement="right">
                <i class="el-icon-info-ms"></i>
              </el-tooltip>
            </el-col>
            <el-col :span="8" class="database_list">
              权限状态: <span>{{ fundInfo.status }}</span>
            </el-col>
          </el-col>
        </el-row>

        <el-row v-if="showAddOrRemoveMyList">
          <el-col :span="4">
            <el-col @click.native="handlefundInformation(fundInfo.symbol)" class="database_action_button"
              style="cursor: pointer;">
              <span :class="imageUrl"></span><span v-if="fundStatus == '添加到我的列表' || fundStatus == ''">{{ fundStatus
                }}</span><span v-if="fundStatus == '从我的列表中移除'" style="color: red;">{{ fundStatus }}</span>
            </el-col>
          </el-col>
        </el-row>
      </el-row>
      <el-row>
        <el-row><br />
          <el-col :span="24" class="database_item left_text_align;">
            晨星风险评级变化图
          </el-col>
          <!-- <div
            id="riskAlertCharts"
            class="width-950-important height-350"
          ></div> -->
          <div class="width-950-important height-350 risk-level-chart-container">
            <v-chart :option="orgOptions" autoresize class="risk-level-chart"></v-chart>
          </div>
        </el-row>
        <br />

        <el-row v-if="showFundRiskMarketChart"><br /><br /><br />
          <el-col :span="24" class="database_item left_text_align;">
            基金风险画像
          </el-col>
        </el-row>
        <el-row v-if="showFundRiskMarketChart">
          <el-col :span="24" id="marketRiskPortraitForFund" class="width-940-important height-350">
          </el-col>

        </el-row>
        <el-row class="width-950-important" style="margin-top: 5px;" v-if="showFundRiskMarketChart">
          <el-col :span="13" class="fund_total_number left_text_align">注：最大回撤期间为5年</el-col>
          <el-col :span="11" class="risk_date right_text_align">截止日期：{{ marketRiskPortraitDate }}</el-col>
        </el-row>

        <el-row style="display:none;">
          <el-col>
            <br /><br />
            <el-table :data="tableData">
              <el-table-column prop="effectiveDate" label="评价时间" width="230">
              </el-table-column>
              <el-table-column prop="totalRisk" label="风险等级" width="200">
              </el-table-column>
              <el-table-column prop="comparePreTotalRisk" label="调整情况" width="200"><template slot-scope="scope">
                  {{
                    scope.row.comparePreTotalRisk | fillNull
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="adjustment" label="调整原因">
                <template slot-scope="scope">
                  {{ scope.row.adjustment | fillNull }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="params.page" :page-sizes="[
                12,
                20,
                40,
                80,
                pagination && pagination.count,
              ]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper"
              :total="(pagination && pagination.count) || 0" v-if="pagination.count > 12 ? true : false">
            </el-pagination>
          </el-col>
        </el-row>

        <el-row class="width-950-important">
          <br v-if="!showFundRiskMarketChart" />
          <br v-if="!showFundRiskMarketChart" />
          <el-col :span="23" class="database_item left_text_align ">
            管理人公布信息
          </el-col>
          <div>
            <el-col :span="8" class="database_list">
              风险评级:
              <span>{{
                fundInfo.totalRiskCompanyLevel | fillNull
              }}</span>
            </el-col>
            <el-col :span="8" class="database_list">
              更新时间:
              <span>{{
                fundInfo.lastUpdateCompanyLevel | fillNull
              }}</span>
            </el-col>
            <el-col :span="8" class="database_list">
              是否低于管理人评级:
              <span>{{
                fundInfo.compareTotalRiskCompanyLevel | fillNull
              }}</span>
            </el-col>
          </div>
        </el-row>
      </el-row>

    </el-row>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import {
  getSymbolHistoricalEvaluation,
  addCustomSymbolList,
  removeCustomSymbolList,
} from "../../api/suitability";
import { riskCharts } from "./mixin/riskCharts";

const componentsCommon = require("cb-components-common").default;
const RISK_LEVEL_CHART_VIEWPORT_LEFT = 90;
const RISK_LEVEL_CHART_VIEWPORT_TOP = 25;
const RISK_LEVEL_CHART_VIEWPORT_WIDTH = 950;
const RISK_LEVEL_CHART_VIEWPORT_HEIGHT = 350;

const getMyListTypeByCustom = componentsCommon.common.getMyListTypeByCustom

const checkResponseStatus = componentsCommon.common.checkResponseStatus;
const stringToHundredMillion = componentsCommon.common.stringToHundredMillion;
const getItsNormalUer = componentsCommon.common.getItsNormalUer;
const SearchByAutoComplete = componentsCommon.search.SearchByAutoComplete;
const getNameAndValue = componentsCommon.localStorage.getNameAndValue;
const marketRiskPortraitChart = componentsCommon.riskPortrait.marketRiskPortraitChart;
const marketRiskPortraitChartForFund = componentsCommon.riskPortrait.marketRiskPortraitChartForFund;
const marketRiskPortraitChartForFundNew = componentsCommon.riskPortrait.marketRiskPortraitChartForFundNew;
const searchBox = componentsCommon.mixin.searchBox.searchBox;

export default {
  mixins: [searchBox, riskCharts],
  data() {
    return {
      orgOptions: {
        textStyle: {
          fontFamily: 'intrinsic'
        },
        xAxis: {
          type: 'category',
          data: [],
          show: true,
          minorTick: {
            show: true
          },
          axisLabel: {
            show: true,
            inside: false,
            fontWeight: 'bold'
          },
        },
        yAxis: {
          alignTicks: {
            alignWithLabel: true
          },
          minorTick: {
            show: false
          },
          data: [1, 2, 3, 4, 5],
          axisLabel: {
            show: true,
            inside: false,
            formatter: 'R{value}',
            fontWeight: 'bold'
          },
          splitArea: {
            show: true,
            color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          },
          axisTick: {
            inside: false,
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            axis: 'auto',
            snap: true,
            animation: true
          },
          position(point, params, dom, rect, size) {
            const offset = 12;
            const tooltipWidth = size.contentSize[0];
            const tooltipHeight = size.contentSize[1];
            const minX = RISK_LEVEL_CHART_VIEWPORT_LEFT + 8;
            const maxX = RISK_LEVEL_CHART_VIEWPORT_LEFT + RISK_LEVEL_CHART_VIEWPORT_WIDTH - tooltipWidth - 8;
            const minY = RISK_LEVEL_CHART_VIEWPORT_TOP + 8;
            const maxY = RISK_LEVEL_CHART_VIEWPORT_TOP + RISK_LEVEL_CHART_VIEWPORT_HEIGHT - tooltipHeight - 8;

            let x = point[0] + offset;
            if (x > maxX) {
              x = point[0] - tooltipWidth - offset;
            }
            x = Math.max(minX, Math.min(x, maxX));

            let y = point[1] - tooltipHeight - offset;
            if (y < minY) {
              y = point[1] + offset;
            }
            y = Math.max(minY, Math.min(y, maxY));

            return [x, y];
          },
          formatter(params) {
            for (var i = 0; i < params.length; i++) {
              if (params[i].data.name == '无变化') {
                return "调整原因 <span style='font-weight:600;'>" + params[i].data.name + "</span>";
              } else {
                return "调整原因 <span style='font-weight:600;color:red;'>" + params[i].data.name + "</span>";
              }
            }
          }
        },
        series: [{
          data: [],
          type: 'line',
          smooth: true
        }]
      },
      dateList: [],
      totalRisksList: [],

      disabledButton: false,
      symbol: "",
      imageUrl: "image_url_minus",
      searchPopoverVisible: false,
      symbolList: [],
      fundStatus: "",
      marketRiskPortraitDate: "",
      fundRiskMarketTimeout: null,
      fundRiskMarketTimeoutUpdate: null,
      showFundRiskMarketChart: false,
      showFund: false,
      loading: false,
      pagination: {
        skip: 0,
        limit: 12,
        count: 0,
      },
      params: {
        sort: "effectiveDate",
        order: "desc",
        limit: 12,
        skip: 0,
        page: 1,
      },
      fundInfo: {
        symbol: "",
        className: "",
        ipoDate: "",
        inceptionDate: "",
        specialCategory: "",
        totalNetAsset: "",
        status: "",
        riskText: "",
      },
      tableData: [],
      timeout: null,
      showAddOrRemoveMyList: false,
      showTerminatedFundInfo: false
    };
  },
  updated() {
    this.dateList = this.dateList;
  },
  mounted() {
    const searchData = getNameAndValue("searchData");
    if (searchData != null && searchData != undefined) {
      this.symbolList = JSON.parse(searchData);
    }

    this.orgOptions
  },
  filters: {
    fillNull(value) {
      if (value != undefined && value != null && value != "") {
        return value;
      } else {
        return "--";
      }
    },
  },
  methods: {
    symbolHistoricalEvaluation(params) {
      let self = this;
      self.disabledButton = true;
      self.loading = true;
      self.showFundRiskMarketChart = false;
      getSymbolHistoricalEvaluation(params)
        .then((response) => {
          let result = response.data;
          if (result !== undefined && result.data !== undefined) {
            if (checkResponseStatus(result, self)) {
              self.tableData = result.data.historicalEvaluation;
              self.fundInfo = result.data.fundInfo;
              self.symbol = self.fundInfo.symbol;
              self.marketRiskPortraitDate =
                result.data.fundClassMarketRiskPortraitForFund.effectiveDate;
              self.fundInfo.totalNetAsset = stringToHundredMillion(
                self.fundInfo.totalNetAsset
              );
              self.showFund = true;
              switch (self.fundInfo.status) {
                case "已订阅":
                  self.fundStatus = "从我的列表中移除";
                  self.imageUrl =
                    "image_url_minus button_space";
                  break;
                case "未订阅":
                  self.fundStatus = "添加到我的列表";
                  self.imageUrl =
                    "image_url_plus button_space";
                  break;
              }

              self.showTerminatedFundInfo = self.fundInfo.fundClassStatus == '0' ? true : false;

              let effectiveDate = [];
              let totalRisks = [];
              let jsonAdjustMent = {};
              let riskAndDate = [];
              let maxRisk = 0;
              for (
                let i = self.tableData.length - 1;
                i > -1;
                i--
              ) {
                let totalRisk = self.tableData[i].totalRisk;
                if (parseInt(totalRisk) > maxRisk) {
                  maxRisk = parseInt(totalRisk);
                }
                let date = self.tableData[i].effectiveDate;
                if (date) {
                  let temp = date.split("-");
                  date = temp[1] + "/" + temp[0];
                }
                let adjust = self.tableData[i].adjustment;

                if (!adjust) {
                  adjust = "无变化";
                }
                effectiveDate.push(date);
                riskAndDate.push(JSON.parse(
                  '{"value":"' + self.tableData[i].totalRisk + '" , "name":"' + adjust + '"}',
                ))
                totalRisks.push(self.tableData[i].totalRisk);
                jsonAdjustMent = Object.assign(
                  jsonAdjustMent,
                  JSON.parse(
                    '{"' + date + '":"' + adjust + '"}'
                  )
                );
              }
              self.orgOptions.xAxis.data = effectiveDate;
              self.orgOptions.series[0].data = riskAndDate;
              // self.alterRisk(
              //     effectiveDate,
              //     totalRisks,
              //     "调整原因",
              //     "#riskAlertCharts",
              //     jsonAdjustMent,
              //     maxRisk
              // );

              self.showFundRiskMarketChart =
                result.data.fundClassMarketRiskPortrait !=
                null &&
                result.data
                  .fundClassMarketRiskPortraitForFund !=
                null &&
                result.data.riskPortraitNew != null &&
                result.data.riskPortraitBenchMarkNew != null &&
                result.data.fundClassMarketRiskPortraitForFund
                  .totalRisk != null;

              if (self.showFundRiskMarketChart) {
                marketRiskPortraitChartForFundNew(
                  this,
                  result.data.riskPortraitNew,
                  result.data.riskPortraitBenchMarkNew,
                  result.data
                    .fundClassMarketRiskPortraitForFund
                    .totalRisk,
                  "#marketRiskPortraitForFund",
                  result.data.minY,
                  result.data.maxY
                );
              }
            }
          }
        })
        .catch((err) => {
          self.loading = false;
          Message({
            message: "数据异常，请尝试刷新再试！",
            type: "error",
            duration: 0.5 * 1000,
          });
          Message.close = function () { };
        })
        .finally((r) => {
          self.loading = false;
          self.disabledButton = false;
        });
    },
    searchDataByAutoComplete(queryString) {
      const self = this;
      let results = self.symbolList;
      self.state.length = 0;
      self.state.push(
        "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold'>基金名称</span>" +
        "<span class='searchbox_service font_bold'>服务状态</span>"
      );
      if (results !== undefined) {
        for (let i = 0; i < results.length; i++) {
          const value =
            results[i].symbol +
            "    " +
            results[i].name +
            "    " +
            results[i].status;
          let htmlString = value.replace(
            queryString,
            "<b style='color:red;'>" + queryString + "</b>"
          );
          htmlString = htmlString.replace(
            "    ",
            "</span><span class='searchbox_title'>"
          );
          htmlString = htmlString.replace(
            "    ",
            "</span><span class='searchbox_service'>"
          );
          htmlString = htmlString.replace("未订阅", "<b>未订阅</b>");
          if (i === 0) {
            self.firstSymbol = results[i].symbol;
            self.state.push(
              "<span class='searchbox_symbol'>" +
              htmlString +
              "</span>"
            );
          } else {
            self.state.push(
              "<span class='searchbox_symbol'>" +
              htmlString +
              "</span>"
            );
          }
        }
      }
      if (results === undefined || results.length === 0) {
        self.state.length = 0;
        self.state.push(
          "<span class='font_bold'>抱歉，没有找到和" +
          "<b style='color:red;'>" +
          queryString +
          "</b>" +
          "相关的内容</span>"
        );
      }
      self.$refs.search_scrollbar.update();
    },
    searchFundInformation() {
      const self = this;
      let symbol = self.symbol;
      self.getFundInformation(symbol.replace(/\"/g, "'"));
    },
    getFundInformation(symbolValue) {
      this.showAddOrRemoveMyList = getMyListTypeByCustom();
      if (!symbolValue)
        return;

      let self = this;
      if (
        symbolValue.indexOf("</span><span class='searchbox_title'>") >
        -1
      ) {
        self.searchPopoverVisible = false;
        symbolValue = symbolValue.split(
          "</span><span class='searchbox_title'>"
        )[0];
        symbolValue = symbolValue
          .replace("<b style='color:red;'>", "")
          .replace("<span class='searchbox_symbol'>", "")
          .replace("</b>", "");
      }
      if (!isNaN(Number(symbolValue))) {
        let param = Object.assign(self.params, { symbol: symbolValue });
        self.symbolHistoricalEvaluation(param);
      }
    },
    addfundInformation(params) {
      let self = this;
      self.loading = true;
      addCustomSymbolList({ symbol: params })
        .then((response) => {
          let jsonData = response.data;
          if (jsonData == undefined) {
            Message({
              message: "数据异常，请尝试刷新再试！",
              type: "error",
              duration: 1 * 1000,
            });
            Message.close = function () { };
          } else {
            if (checkResponseStatus(jsonData, self)) {
              Message({
                message:
                  "成功添加" + params + "基金代码到列表！",
                type: "success",
                duration: 1 * 1000,
              });
              Message.close = function () {
                self.getFundInformation(params);
              };
            }
          }
          self.loading = false;
        })
        .catch((err) => {
          self.loading = false;
          Message({
            message: "数据异常，请尝试刷新再试！",
            type: "error",
            duration: 1 * 1000,
          });
          Message.close = function () { };
        })
        .finally((r) => {
          self.loading = false;
        });
    },
    removefundInformation(params) {
      let self = this;
      self.loading = true;
      removeCustomSymbolList({ symbol: params })
        .then((response) => {
          let jsonData = response.data;
          if (jsonData == undefined) {
            Message({
              message: "数据异常，请尝试刷新再试！",
              type: "error",
              duration: 1 * 1000,
            });
            Message.close = function () { };
          } else {
            if (checkResponseStatus(jsonData, self)) {
              Message({
                message:
                  "成功移除列表里的" + params + "基金代码！",
                type: "success",
                duration: 1 * 1000,
              });
              Message.close = function () {
                self.getFundInformation(params);
              };
            }
          }
          self.loading = false;
        })
        .catch((err) => {
          self.loading = false;
          Message({
            message: "数据异常，请尝试刷新再试！",
            type: "error",
            duration: 1 * 1000,
          });
          Message.close = function () { };
        })
        .finally((r) => {
          self.loading = false;
        });
    },
    handlefundInformation(params) {
      const self = this;
      if (!self.disabledButton) {
        self.disabledButton = true;
        if (self.fundStatus == "添加到我的列表") {
          self.addfundInformation(params);
        } else {
          self.removefundInformation(params);
        }
      }
    },
    handleSizeChange(val) {
      const self = this;
      self.params.limit = val;
      self.getFundInformation(self.fundInfo.symbol);
      // self.params.order = "desc";
      // self.params.sort = "lastUpdate";
    },
    handleCurrentChange(val) {
      const self = this;
      self.params.page = val;
      self.params.skip = (val - 1) * self.params.limit;
      self.getFundInformation(self.fundInfo.symbol);
      // self.params.order = "desc";
      // self.params.sort = "lastUpdate";
    },
  },
};
</script>
<style lang="scss">
@import "../../public/sass/components/database";
</style>
<style scoped>
.risk-level-chart-container {
  overflow: hidden;
}

.risk-level-chart {
  position: relative;
  top: -25px;
  left: -90px;
  width: 1140px;
  height: 425px;
}
</style>
